import { useRef, useEffect } from 'react';
import createHeartbeatWorker from '../workers/createHeartbeatWorker';

/**
 * 心跳子线程逻辑
 */
export default function useHeartbeat(option: {
  handler: (event: MessageEvent) => void;
  errorHandler: (error: any) => void;
}) {
  const { handler, errorHandler } = option || {};

  // 心跳子线程
  const worker = useRef<Worker | null>(null);

  // 给心跳子线程发送消息
  const postMessageWorker = (payload: any) => {
    if (!worker.current) return;
    worker.current.postMessage(payload);
  };

  // 处理心跳子线程回传的消息
  const startListener = () => {
    if (!worker.current) return;
    worker.current.addEventListener('message', handler, false);
    worker.current.addEventListener('error', errorHandler, false);
  };

  // 停止监听心跳子线程消息
  const stopListener = () => {
    if (!worker.current) return;
    worker.current.removeEventListener('message', handler);
    worker.current.removeEventListener('error', errorHandler);
  };

  // 关闭心跳子线程
  const terminateWorker = () => {
    if (!worker.current) return;
    worker.current.terminate();
  };

  // 监听、移除监听 心跳子线程消息
  useEffect(() => {
    // 监听心跳子线程回传的消息
    startListener();

    return () => {
      // 停止监听心跳子线程消息
      stopListener();
    };
  }, [handler]);

  // 初始化 创建心跳子线程
  useEffect(() => {
    // 创建心跳子线程worker
    worker.current = createHeartbeatWorker();

    return () => {
      // 停止监听心跳子线程消息
      stopListener();
      // 关闭心跳子线程
      terminateWorker();
    };
  }, []);

  return {
    worker,
    postMessageWorker,
    terminateWorker,
  };
}
